import styled from 'styled-components'

export const UserInputItem = styled.li`
  list-style-type: none;
`

export const UserEnteredDetails = styled.p`
  color: #0f172a;
  font-weight: bold;
  font-size: 18px;
  font-family: 'Roboto';
`
